<template>
  <div>
    <div class="iq-sub-dropdown">
      <div class="iq-card shadow-none m-0">
        <div class="iq-card-body p-0">
          <div class="bg-primary p-3">
            <h5 class="mb-0 text-white">
              New Messages
              <small class="badge badge-light float-right pt-1">{{
                getNewMsgs.length
              }}</small>
            </h5>
          </div>
          <a
            href="javascript:void(0)"
            class="iq-sub-card"
            v-for="(item, index) in getNewMsgs"
            :key="index"
          >
            <div
              class="media align-items-center"
              @click="fnGetQuoteListingPage(item)"
            >
              <div class>
                <i class="las la-envelope rounded fs-1500"></i>

                <!-- <img class="avatar-40 rounded" :src="item.image" alt="img" /> -->
              </div>
              <div class="media-body ml-3">
                <h6 class="mb-0">{{ item.subject }}</h6>
                <small class="float-left font-size-12">
                  {{ item.updated_at | dateConvertDDMMYYYYTime }}
                </small>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../services/auth.service'
export default {
  name: 'NewEmailNotificationDropdownList',
  components: {},
  data() {
    return {
      loginUser: {}
    }
  },
  computed: {
    ...mapGetters(['getNewMsgs']),
    currentRouteName() {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions([
      'fetchNewMsgs',
      'fetchQuotePaginate',
      'fetchAdminQuotePaginate'
    ]),
    fnGetQuoteListingPage(item) {
      if (this.loginUser.role_id == 4) {
        let obj = {
          dealerUserId: this.loginUser.id,
          page: 1,
          recordsPerPage: 15,
          q: item.quoteId,
          selectedStatus: '',
          sort_direction: '',
          sort_field: 'id'
        }

        if (this.currentRouteName != 'dealer.quoteList') {
          this.$router.push({ name: 'dealer.quoteList' })
        }

        this.fetchQuotePaginate(obj)
      } else if (this.loginUser.role_id == 1 || this.loginUser.role_id == 2) {
        let obj = {
          page: 1,
          recordsPerPage: 15,
          q: item.quoteId,
          selectedStatus: '',
          sort_direction: '',
          sort_field: 'id'
        }

        if (this.currentRouteName != 'admin.quoteList') {
          this.$router.push({ name: 'admin.quoteList' })
        }

        this.fetchAdminQuotePaginate(obj)
      }
    }
  },
  created() {
    this.loginUser = authService.getUserFromToken()
    // To load new msg
    if (this.loginUser.role_id == 4) {
      this.fetchNewMsgs({
        dealerUserId: this.loginUser.id,
        reader: 'other'
      })
    } else {
      this.fetchNewMsgs({
        dealerUserId: '',
        reader: 'vsa'
      })
    }
  }
}
</script>
